import React from "react";

// Botao vetorial de fechar, seguindo o mesmo recorte do menu aberto.
export const CloseCombined = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 202 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block" }}
    preserveAspectRatio="xMaxYMin meet"
  >
    <path
      d="M202.001 0H6.00017C6.00017 0 8.97379 81.398 50.0735 122.638C91.1732 163.879 202.001 142.419 202.001 142.419V0Z"
      fill="#009FE3"
    />
    <path
      d="M202.001 0H43.0989C43.0989 0 21.3861 82.998 60.4691 121.993C99.552 160.988 202.001 141.214 202.001 141.214V0Z"
      fill="#234E9E"
    />
    <path
      d="M108 40L154 86"
      stroke="white"
      strokeWidth="6.5"
      strokeLinecap="round"
    />
    <path
      d="M154 40L108 86"
      stroke="white"
      strokeWidth="6.5"
      strokeLinecap="round"
    />
  </svg>
);
